import { createContext, useContext } from 'react';

export interface AuthContextType {
  isLoggedIn: boolean;
  token: string | null;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextType>({
  isLoggedIn: false,
  token: null,
  logout: () => {},
});

export const useAuth = () => useContext(AuthContext);
